import { IRequestService } from "../../service/request/RequestService";
import { IRequest } from "../../model/request/Request";

export default class CreateRequestTypeInteractor {
  private requestService: IRequestService;

  constructor(requestService) {
    this.requestService = requestService;
  }

  async execute(request: IRequest) {
    return this.requestService.createRequest(request);
  }
}
